import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.selectedParcelsName;

export const SelectedParcelsNameFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "Package name",
  Icon: PackageIcon,
  operators: entry.operators,
  valueFetcher: fetcher,
  dbSearch: true,
  displayName: entry.displayName,
});
